import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../assets/styles/Header.css';
import ThemeToggle from '../components/ThemeToggle';

function Header() {
    const [activeLink, setActiveLink] = useState('/');
    const location = useLocation();

    useEffect(() => {
        setActiveLink(location.pathname);
    }, [location]);

    return (
        <header className="header" role="banner">
            <nav className="nav-links" aria-label="Main navigation">
                <Link 
                    to="/" 
                    className={activeLink === '/' ? 'active' : ''} 
                    aria-current={activeLink === '/' ? 'page' : null}
                >
                    home
                </Link>
                {/* You can uncomment this when blog is implemented */}
                {/* <Link 
                    to="/blog" 
                    className={activeLink === '/blog' ? 'active' : ''} 
                    aria-current={activeLink === '/blog' ? 'page' : null}
                >
                    blog
                </Link> */}
            </nav>
            <ThemeToggle />
        </header>
    );
}

export default Header;